import PaymentPolicy from "./payment-policy.page";

export default PaymentPolicy;
